import { SeatIndividualSuiteIcon } from './SeatIndividualSuiteIcon';

/**
 * author: Google
 * id A8F9F185-D2AE-4DEE-845C-3C74801E2CD0
 * name seat-individual-suite
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-individual-suite.svg
 * tags
 */
export const AirlineSeatIndividualSuiteIcon = SeatIndividualSuiteIcon;
export default AirlineSeatIndividualSuiteIcon